import { Route, Routes, useLocation } from "react-router-dom";
import "./utilities/axios";
// Pages and Components
import BottomNavBar from "./components/BottomNavBar";
import FileView from "./components/FileView";
import Header from "./components/Header";
import { ClikkleProvider } from "./context/ClikkleContext";
import { ResourceMenuProvider } from "./context/ResourceMenuContext";
import { UserProfileProvider } from "./context/UserProfileContext";
import {
  // Home,
  // Favorite,
  // Trash,
  // Recent,
  // SharedByMe,
  // SharedWithMe,
  MyFiles,
  ResourceViewer,
} from "./pages";
import { Suspense } from "react";
import Loading from "./components/Loading";
import LoginForm from "./pages/auth/Login";
import SignupForm from "./pages/auth/Signup";
import ThemeContextProvider from "./style/theme";
import { CssBaseline } from "@mui/material";
import SignupTrial from "./pages/SignupTrial";
import TrialActivation from "./pages/TrialActivate"

const App = () => {
  const location = useLocation();

  if (location.pathname === "/login") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <LoginForm />
        </Suspense>
      </ThemeContextProvider>
    );
  }

  if (location.pathname === "/signup") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <SignupForm />
        </Suspense>
      </ThemeContextProvider>
    );
  }
  if (location.pathname === "/register") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <SignupTrial />
        </Suspense>
      </ThemeContextProvider>
    );
  }
  if (location.pathname === "/register/trialactivate") {
    return (
      <ThemeContextProvider>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <TrialActivation />
        </Suspense>
      </ThemeContextProvider>
    );
  }
  return (
    <ClikkleProvider>
      <Routes>
        <Route path="/file/:fileId/:userId" element={<FileView />} />
      </Routes>
      <UserProfileProvider>
        <ResourceMenuProvider>
          <Header>
            <Routes>
              <Route path="/" element={<MyFiles />} />
              <Route path="/view" element={<ResourceViewer />} />
              <Route path="/trash" element={<MyFiles />} />
              <Route path="/my-files" element={<MyFiles />} />
              <Route path="/favorite" element={<MyFiles />} />
              <Route path="/recent" element={<MyFiles />} />
              <Route path="/shared-by-me" element={<MyFiles />} />
              <Route path="/shared-with-me" element={<MyFiles />} />
            </Routes>
            <BottomNavBar />
          </Header>
        </ResourceMenuProvider>
      </UserProfileProvider>
    </ClikkleProvider>
  );
};

export default App;
